<template>
    <div class="app-container">
      <SiderBar />
      <main class="main-content">
        <router-view />
      </main>
    </div>
  </template>
  
  <script>
  import SiderBar from './Sidebar.vue'
  
  export default {
    components: {
      SiderBar
    }
  }
  </script>
  
  <!-- 保持原来的样式 -->